'use strict';

const regex = /[^a-zA-Z\-0-9]/

module.exports = function(input){
  return !regex.test(input);
};